import type { RegionKey, USState } from '../types';
import { ACCOMMODATIONS, TASTING_STOPS } from './data';
import { REGIONS } from './regions';

export type RegionHubKey = RegionKey;

export interface TrailStateHub {
  state: USState;
  slug: string;
  title: string;
  eyebrow: string;
  subtitle: string;
  bestFor: string[];
  accent: string;
}

export interface TrailRegionHub {
  key: RegionKey;
  state: USState;
  title: string;
  shortTitle: string;
  subtitle: string;
  mood: string;
  bestFor: string[];
  stopIds: string[];
  stayIds: string[];
}

export const STATE_HUBS: TrailStateHub[] = [
  {
    state: 'OR',
    slug: 'oregon-truffle-guide',
    title: 'Oregon Truffle Guide',
    eyebrow: 'Oregon routes / winter trips / spring shoulder season',
    subtitle:
      'The guide currently centers on four Oregon patterns: a Portland foothills day-trip leg, the compact Willamette Valley weekend, a Eugene event-and-training leg, and a lighter Corvallis academic micro-zone.',
    bestFor: ['Forest outings', 'Festival travel', 'City-base trips', 'Academic weekends'],
    accent: 'Fir, umber, fog',
  },
];

export const REGION_HUBS: TrailRegionHub[] = REGIONS.map((region) => ({
  key: region.key,
  state: region.state,
  title: region.title,
  shortTitle: region.shortTitle,
  subtitle: region.subtitle,
  mood: region.mood,
  bestFor: region.bestFor,
  stopIds: TASTING_STOPS.filter((stop) => stop.region === region.key).map((stop) => stop.id),
  stayIds: ACCOMMODATIONS.filter((stay) => stay.region === region.key).map((stay) => stay.id),
}));

export function getRegionHubForLocation(locationId: string): TrailRegionHub | undefined {
  return REGION_HUBS.find(
    (hub) => hub.stopIds.includes(locationId) || hub.stayIds.includes(locationId),
  );
}

export function getStateHub(state: USState): TrailStateHub | undefined {
  return STATE_HUBS.find((hub) => hub.state === state);
}

export function getStateHubBySlug(slug: string): TrailStateHub | undefined {
  return STATE_HUBS.find((hub) => hub.slug === slug);
}

export function getStateHref(state: USState): string {
  const hub = getStateHub(state);
  return hub ? `/${hub.slug}` : '/';
}

export function getRegionsForState(state: USState): TrailRegionHub[] {
  return REGION_HUBS.filter((region) => region.state === state);
}
